import { render, staticRenderFns } from "./ProductCardWeb.vue?vue&type=template&id=8341812c&scoped=true"
import script from "./ProductCardWeb.vue?vue&type=script&lang=js"
export * from "./ProductCardWeb.vue?vue&type=script&lang=js"
import style0 from "./ProductCardWeb.vue?vue&type=style&index=0&id=8341812c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8341812c",
  null
  
)

export default component.exports